import {
  PopoverElementKind,
  useHoverCardPosition,
} from '../hooks/useHoverCardPosition'

import { Box, Popover, PopoverArrow, PopoverContent } from '@chakra-ui/react'

import { PopoverTrigger } from '@/components/ui'

export interface IProps {
  children: React.ReactNode
  elementId: string
  kind?: PopoverElementKind
  isHovering: boolean
  forceCloseSignal?: number
}

export const FloorPlanPopover = ({
  isHovering = false,
  elementId,
  children,
  kind,
  forceCloseSignal,
}: IProps) => {
  const {
    triggerPosition,
    isOpen,
    onContentMouseEnter,
    onContentMouseLeave,
    onPopoverClose,
  } = useHoverCardPosition({ elementId, isHovering, kind, forceCloseSignal })

  const { x, y, width, height } = triggerPosition
  return (
    <Popover
      autoFocus={false}
      closeOnBlur={true}
      isLazy
      isOpen={isOpen}
      offset={[8, 8]}
      onClose={onPopoverClose}
      returnFocusOnClose={false}
      // Not 'hover': Chakra's own hover trigger schedules an unconditional
      // close on mouseleave that can't be cancelled, which used to kill a
      // card re-opened right after. Open/close is fully driven by the hook.
      // autoFocus/returnFocusOnClose default true under Chakra's default
      // 'click' trigger, which would steal focus from e.g. a search input
      // whenever the pointer happens to rest on a marker long enough to
      // open the card.
    >
      <PopoverTrigger>
        {/* Anchor only, for Popper to position against — pointerEvents='none'
            so a stale rect can never intercept a click on the canvas.
            Known bug (pre-existing, not this PR's to fix): the -60 x-offset
            assumes a collapsed side nav and is off by 180px when it's
            expanded (60px vs 240px). The -65 y-offset is correct. */}
        <Box
          height={height}
          left={x - 60}
          pointerEvents='none'
          pos='absolute'
          top={y - 65}
          width={width}
        />
      </PopoverTrigger>
      <PopoverContent
        border='none'
        onMouseEnter={onContentMouseEnter}
        onMouseLeave={onContentMouseLeave}
        shadow='xl'
        width={kind === 'tailgate' ? '320px' : '400px'}
      >
        <PopoverArrow border='none' />
        {children}
      </PopoverContent>
    </Popover>
  )
}
